import React from 'react';
import {
	Input,
	Select,
	Form,
	Modal,
	DatePicker,
	Upload,
	message,
	Button,
	Icon,
	Col,
	Row,
	Drawer,
	Descriptions,
	Badge,
	Statistic,
	List, Tag, Table
} from 'antd';
import moment from 'moment';
import {server} from "../config";

const PurRepayDetail =(props)=>{
	
	const {onCancel,visible,item} =props;
	console.log("data",item.m_purRepay)
	//定义表头
	const columns = [{
		title: '序号',
		render:(text,record,index)=>`${index+1}`,
		width:30
	},{
		title: '客户名称',
		dataIndex: 'cust_name',
		key: 'cust_name',
		width:100
	},{
		title: '合同号',
		dataIndex: 'contract_id',
		key: 'contract_id',

		width:100
	},{
		title: '借据金额',
		dataIndex: 'loan_amount',
		key: 'loan_amount',

		width:100
	},{
		title: '借款日期',
		dataIndex: 'loan_date',
		key: 'loan_date',
		render:(text)=>(
			<div>

				{text.length >0 ? <span>{moment(text).format('YYYY-MM-DD HH:mm')}</span>:null}
			</div>
		),
		width:100
	},{
		title: '还款时间',
		dataIndex: 'repay_date',
		key: 'repay_date',
		render:(text)=>(
			<div>

				{text.length >0 ? <span>{moment(text).format('YYYY-MM-DD HH:mm')}</span>:null}
			</div>
		),
		width:100
	},{
		title: '本次还款本金(分)',
		dataIndex: 'amount',
		key: 'amount',

		width:100
	},{
		title: '本次还款利息（分）',
		dataIndex: 'interest',
		key: 'interest',

		width:100
	},{
		title: '余额(分)',
		dataIndex: 'remain_loan_amount',
		key: 'remain_loan_amount',

		width:100
	},
	];


	const tabelDefinition = {
		rowKey: 'id',
		columns:  columns,
		dataSource: item.m_purRepay,
		pagination: {hideOnSinglePage:true},
	}


	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.55
	return (
	<Drawer   title={<span>工程通还款明细</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >
		{/*	<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.payee_list,null , 2)}<br/><br/><br/>
                  </pre></Col>
			</Row>*/}
			<Row>
				<Col span={24} style={{ margin: 0, textAlign: 'left' }}>
					<Table {...tabelDefinition}/>
				</Col>
			</Row>


      </Drawer>
	
	)

}


export default PurRepayDetail;
